import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { SectionHeader } from '@pages/IntroducingBroker/Dashboard/components/SectionHeader/SectionHeader'
import { CustomTargetLink } from '@pages/IntroducingBroker/LinkHub/Links/CustomTargetLink'
import { PersonalisedTargetLink } from '@pages/IntroducingBroker/LinkHub/Links/PersonalisedTargetLink'
import { PredefinedLink } from '@pages/IntroducingBroker/LinkHub/Links/PredefinedLink'
import { RegistrationLink } from '@pages/IntroducingBroker/LinkHub/Links/RegistrationLink'

import { Grid } from '@ui/Layouts/Grid/Grid'
import { Divider } from '@ui/components/Divider'
import { SpacingType } from '@ui/design-system/spacing'

import { useWindowResize } from '@utils/domUtils'

import { useElementSize } from '@hooks/useElementSize'
import { useIBLink } from '@hooks/useIBLink'
import { useIBReferralCodes } from '@hooks/useIBReferralCodes'

import { Box } from '@shared/components/Box'
import { Loading } from '@shared/components/Loading/Loading'

import styles from '../Dashboard/ReferralLink/ReferralLink.module.scss'

export const LinkHubPage = () => {
  const { ref, size } = useElementSize<HTMLDivElement>()
  const { ibCode, mtCode, isLoading: isLoadingReferralCodes } = useIBReferralCodes()

  const {
    ibLink,
    mtLink,
    isLoading: isLoadingIBLinks,
    fetchShortenedIBLink,
  } = useIBLink(ibCode, mtCode)

  const { t } = useTranslation()
  const isMobile = useWindowResize()

  const LinksContainerStyles: { outerGap: SpacingType; innerGap: SpacingType } = isMobile
    ? {
        outerGap: 'x24',
        innerGap: 'x32',
      }
    : {
        outerGap: 'x32',
        innerGap: 'x40',
      }

  return (
    <Box
      flex
      direction='column'
      gap={LinksContainerStyles.outerGap}
      className={styles.iBReferralLink}
      maxWidth={1232}
    >
      <SectionHeader title={t('IB.LinkHubPage.Link Hub')} />
      <Loading isLoading={isLoadingReferralCodes || isLoadingIBLinks} showLoadingIcon>
        <Grid
          className={classNames(styles.linksContainer)}
          maxCardWidth={384}
          gap={LinksContainerStyles.innerGap}
          mobileGridTemplateColumns='minmax(0, 1fr)'
        >
          <RegistrationLink
            ibCode={ibCode}
            mtCode={mtCode}
            ibLink={ibLink}
            mtLink={mtLink}
            fetchShortenedIBLink={fetchShortenedIBLink}
            ref={ref}
          />
          <PredefinedLink
            ibCode={ibCode}
            mtCode={mtCode}
            ibLink={ibLink}
            mtLink={mtLink}
            fetchShortenedIBLink={fetchShortenedIBLink}
          />
          <CustomTargetLink
            ibCode={ibCode}
            mtCode={mtCode}
            ibLink={ibLink}
            mtLink={mtLink}
            fetchShortenedIBLink={fetchShortenedIBLink}
          />
        </Grid>
        <Divider.Horizontal />
        <PersonalisedTargetLink
          ibCode={ibCode}
          mtCode={mtCode}
          fetchShortenedIBLink={fetchShortenedIBLink}
          cardWidth={size.width}
        />
      </Loading>
    </Box>
  )
}
